import { withErrorBoundary } from 'components/common/MartyErrorBoundary';
import { SelectedFilterList } from 'components/search/SelectedFilterList/SelectedFilterList';
import useMartyContext from 'hooks/useMartyContext';
import { useFacetsContext } from 'components/search/Facets/FacetsProvider';
import { yieldToMain } from 'helpers/index';

export const CompactSingleSelects = ({ filters, hasAutoScroll, removePersonalizedSize, clearFilters }) => {
  const {
    actions: { handleBreadcrumbPillClick }
  } = useFacetsContext();
  const { testId } = useMartyContext();

  if (!filters.breadcrumbs.length && !filters?.pills?.recommendations?.length) {
    return null;
  }

  const makeBreadcrumbClickHandler = crumb => e => {
    e.preventDefault();
    if (filters?.personalizedSize?.sizes?.includes(crumb.name)) {
      removePersonalizedSize();
    }

    handleBreadcrumbPillClick(crumb);
  };

  const handleClearFilters = async () => {
    await yieldToMain();
    clearFilters();
  };

  const breadcrumbs = filters?.breadcrumbs ?? [];

  return (
    <SelectedFilterList.Root className="flex-col md:mb-6" hasAutoScroll={hasAutoScroll}>
      <SelectedFilterList.Heading data-test-id={testId('breadcrumbTitle')}>Filters</SelectedFilterList.Heading>

      <div className={'flex items-center gap-4'} data-test-id={testId('breadcrumbScroll')}>
        {breadcrumbs.length > 0 && (
          <SelectedFilterList.ClearButton onClick={handleClearFilters} className="max-md:hidden">
            Clear Filters
          </SelectedFilterList.ClearButton>
        )}

        <SelectedFilterList.ScrollButton direction="left" data-test-id={testId('leftBreadcrumbScroll')} />

        <SelectedFilterList.FilterItems
          id="searchSelectedFilters"
          className="max-md:mb-4 max-md:snap-none max-md:scroll-p-2 max-md:px-2"
          data-test-id={testId('breadcrumbContainer')}
        >
          {breadcrumbs.map(crumb => {
            const { name, removeUrl } = crumb;
            const isSingleSelect = Object.keys(filters.selected.singleSelects).some(e => filters.selected.singleSelects[e][0] === name);
            const crumbTitle = `Remove ${crumb.name} filter`;

            return (
              <SelectedFilterList.FilterItem
                key={`${removeUrl}-${name}`}
                removeUrl={crumb.removeUrl}
                aria-label={crumbTitle}
                data-singleselect={isSingleSelect}
                onClick={makeBreadcrumbClickHandler(crumb)}
                data-test-id={testId('singleSelectBreadcrumb')}
              >
                {crumb.name}
              </SelectedFilterList.FilterItem>
            );
          })}
        </SelectedFilterList.FilterItems>

        <SelectedFilterList.ScrollButton direction="right" data-test-id={testId('rightBreadcrumbScroll')} />
      </div>
    </SelectedFilterList.Root>
  );
};

export default withErrorBoundary('CompactSingleSelects', CompactSingleSelects);
